import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "meetUpLogin"
};
const _hoisted_2 = {
  class: "meetUpLogin_con"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("header", {
  class: "meet_qrcode"
}, "成都工业学院数字化教育教学平台", -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_qrCode_link = _resolveComponent("qrCode-link");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("section", null, [_createVNode(_component_qrCode_link)])])]);
}